
import AppButton from "@/components/AppButton.vue";
import BottomNavigation from "@/components/BottomNavigation.vue";
import ContactChoiceModal from "@/components/ContactChoiceModal.vue";
import HeaderHome from "@/components/HeaderHome.vue";
import ModalCodigo from "@/components/ModalCodigo.vue";
import SlideNav from "@/components/SlideNav.vue";
import Slidetify from "@/components/Slidetify.vue";
import Util from "@/ts/Util";
import feather from "feather-icons";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    HeaderHome,
    BottomNavigation,
    SlideNav,
    Slidetify,
    ModalCodigo,
    AppButton,
    ContactChoiceModal,
  },
  props: {
    bottomNav: {
      type: Boolean,
      default: false,
    },
    userData: [Array, Object],
    componentKey: Number,
    notificationsKey: Number,
    pageTitle: String,
    imgLogo: String,
  },
})
export default class HomeContainer extends Vue {
  modalMsg = "";
  openModalLogout = false;
  organizationData: any = JSON.parse(
    sessionStorage.getItem("ORGANIZATION_DATA") || ""
  );
  isStores = sessionStorage.getItem("GO_TO_STORE");
  qrMesa: boolean = JSON.parse(sessionStorage.getItem("QRMesa") || "false");
  drawer: any = false;
  showModalLogoff = false;
  loginType = { isSimpleLogin: false, simpleLoginType: null };

  homeLayout = sessionStorage.getItem("HOME_LAYOUT") || "feed";

  get loginTypeConsumer() {
    this.loginType = JSON.parse(
      sessionStorage.getItem("loginTypeInfo") ||
        '{"isSimpleLogin": false, "simpleLoginType": null}'
    );

    if (
      this.loginType.isSimpleLogin &&
      this.loginType.simpleLoginType == "consumer" &&
      sessionStorage.getItem("USER_ID") == ""
    ) {
      return true;
    } else {
      return false;
    }
  }
  showContactModal = false;
  storeContact: any = {};

  mounted() {
    const bn: any = BottomNavigation;
    const sn: any = Slidetify;
    bn.refresh();
    sn.refresh();

    feather.replace();
    // $(document).ready(function() {
    //   $(".sidenav").sidenav();
    // });
  }

  openLogOut() {
    this.modalMsg = "Você realmente deseja sair da sua conta?";
    this.openModalLogout = true;
  }

  openContactModal() {
    this.showContactModal = true;
  }

  // openChange() {
  //   if (this.organizationData.CONFIGURATIONS.USE_INTEGRATION) {
  //     this.modalMsg =
  //       "Para trocar de clube é necessário sair da sua conta, deseja continuar?";
  //     this.openModalLogout = true;
  //   } else {
  //     $(".sidenav").sidenav("close");
  //     LoginFrontEnd.goToChooseOrganization(() => this.$router.push("HomeApp"));
  //   }
  // }

  logOff() {
    this.showModalLogoff = true;
    this.openModalLogout = false;
    this.drawer = false;
    Util.logOff();
  }

  openSideMenu() {
    this.drawer = !this.drawer;
  }

  cancelLogoff() {
    this.openModalLogout = false;
    Util.cancelLogoff();
  }
}
